import CodeLine from "../CodeLine/CodeLine";
import "./About.scss";

export default function Description() {
  const description = [
    "/**",
    " * Full Stack Developer",
    " * Kian Technology",
    " * Tunis, Tunisia",
    " * Feb 2023 - Apr 2026",
    " * ",
    " * Developed Itona, a ThingsBoard IoT platform managing telemetry for 2000+ devices.",
    " * Built full-stack apps for Fleet, Construction, Parking, and Smart Home solutions.",
    " * Developed Spring Boot APIs and UIs for real-time IoT data processing.",
    " * Integrated telemetry, dashboards, and real-time alerting mechanisms.",
    " * Collaborated with QA, DevOps, and UX teams to deliver end-to-end features.",
    " * Optimized application performance using modern monitoring tools.",
    " * Participated in code reviews, debugging, and production issue resolution.",
    " */",
  ];

  return (
    <div className="description-layout">
      <div className="description-layout__desktop">
        {description.map((line, idx) => (
          <CodeLine
            key={idx}
            lineNumber={idx + 1}
            words={[{ text: line, class: "comment" }]}
          />
        ))}
      </div>

      <div className="description-layout__mobile">
        Full Stack Developer at Kian Technology (Tunis, Tunisia). Developed Itona, a ThingsBoard 
        IoT platform managing telemetry for 2000+ devices. Built full-stack apps for Fleet, 
        Construction, Parking, and Smart Home solutions. Developed Spring Boot APIs and UIs for 
        real-time data processing, integrated telemetry/dashboards, and collaborated across teams 
        to deliver end-to-end features and optimize performance.
      </div>
    </div>
  );
}
